import { TFunction } from 'i18next';
import { formatedDate } from 'utils/general';
import * as yup from 'yup';

export const validationCreateSettlementsSchema = (
  t: TFunction<'common', undefined>
) =>
  yup.object().shape({
    cropsIds: yup
      .array()
      .of(yup.number())
      .min(1, t('choose-at-least-one-element'))
      .required(t('this-field-is-required')),
    // endDate: yup
    //   .date()
    //   .required(t('this-field-is-required'))
    //   .test((value, { parent: { startDate }, createError }) => {
    //     if (startDate && value) {
    //       if (isBefore(value, startDate)) {
    //         return createError({
    //           message: 'start-date-validation',
    //           path: 'endDate',
    //         });
    //       }
    //     }
    //     return true;
    //   }),
    // startDate: yup
    //   .date()
    //   .required(t('this-field-is-required'))
    //   .test((value, { parent: { endDate }, createError }) => {
    //     if (endDate && value) {
    //       if (isBefore(endDate, value)) {
    //         return createError({
    //           message: 'start-date-validation',
    //           path: 'startDate',
    //         });
    //       }
    //     }
    //     return true;
    //   }),
    supplierId: yup.string().required(t('this-field-is-required')),
  });
export const validationCreateWorkerSettlementsSchema = (
  t: TFunction<'common', undefined>
) =>
  yup.object().shape({
    // endDate: yup
    //   .date()
    //   .required(t('this-field-is-required'))
    //   .test((value, { parent: { startDate }, createError }) => {
    //     if (startDate && value) {
    //       if (isBefore(value, startDate)) {
    //         return createError({
    //           message: 'start-date-validation',
    //           path: 'endDate',
    //         });
    //       }
    //     }
    //     return true;
    //   }),
    // startDate: yup
    //   .date()
    //   .required(t('this-field-is-required'))
    //   .test((value, { parent: { endDate }, createError }) => {
    //     if (endDate && value) {
    //       if (isBefore(endDate, value)) {
    //         return createError({
    //           message: 'start-date-validation',
    //           path: 'startDate',
    //         });
    //       }
    //     }
    //     return true;
    //   }),
    workerId: yup.string().required(t('this-field-is-required')),
  });

export const formatAccountingPeriod = ({
  language,
  startDate,
  endDate,
}: {
  language: string;
  startDate?: string;
  endDate?: string;
}) =>
  startDate && endDate
    ? `${formatedDate(startDate, 'dd MMM yyyy', language)} - ${formatedDate(
        endDate,
        'dd MMM yyyy',
        language
      )}`
    : '';
